module.exports = __webpack_public_path__ + "fo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/fo.svg
// module id = 805
// module chunks = 0